// removed by extract-text-webpack-plugin
module.exports = {"container":"_2hj36 _7mR3c","teamPhoto":"_3ADhA","body":"_1iOfF"};


//////////////////
// WEBPACK FOOTER
// ./banquet/containers/MarketingAboutContainer/index.sass
// module id = 1522
// module chunks = 1